import { updatePassword } from "../../../api/repositories/updatePassword";

export default {
  async updatePassword({ commit }, _body) {
    try {
      const data = await updatePassword({ ..._body });
      commit("SET_PASS", {data} );
    } catch (error) {
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
};
